import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";
import { filter } from "lodash";

import SubjectDetails from "./SubjectDetails";
import Identification from "./Identification";
import Administrators from "./Administrators";
import Dispatchers from "./Dispatchers";
import Keys from "./Keys";
import RequestTypes from "./RequestTypes";
import RequestSeriousness from "./RequestSeriousness";

import { getOrganizationNormal } from "../../../actions/resourceActions";
import {DebugElement} from "../../../Atollon/debug";
import {TouchPageHeader, TouchPageHeader_and_content_spaceBetween} from "../../../AtollonTheme/ReactElements";

const OrganizationEdit = ({ history, organization }) => {
  if (!organization) return <div />;
  return (
    <div className="flex-col organization-edit">

        <TouchPageHeader title={`Nastavení organizace ${organization.identifier}`}/>
        <TouchPageHeader_and_content_spaceBetween heightPx={50}/>

      <Identification history={history} identifier={organization.identifier} />
      <SubjectDetails
        initialValues={{
          name: organization.name,
          address1: organization.address ? organization.address.address1 : "",
          address2: organization.address ? organization.address.address2 : "",
          city: organization.address ? organization.address.city : "",
          countryCode:
            organization.address && organization.address.countryCode
              ? organization.address.countryCode
              : "NO_COUNTRY",
          zipCode: organization.address ? organization.address.zipCode : ""
        }}
        organization={organization}
      />
        <DebugElement text={"Administrators --- "}/>
      <Administrators
        items={filter(
          organization.relatedResources,
          item => item.role === "ADMIN"
        )}
        organization={organization}
      />
        <DebugElement text={"Dispatchers --- "}/>
      <Dispatchers
        items={filter(
          organization.relatedResources,
          item => item.role === "DISPATCHER"
        )}
        organization={organization}
      />
      <Keys keys={organization.authorizationKeys} />
      <RequestTypes
        organization={organization}
        items={organization.requestCustomTypes}
      />
      <RequestSeriousness
        organization={organization}
        items={organization.requestSeverities}
      />
    </div>
  );
};

export default compose(
  connect(({ resource: { organization } }) => ({ organization }), {
    getOrganizationNormal
  }),
  lifecycle({
    async componentWillMount() {
      const { getOrganizationNormal, match } = this.props;

      getOrganizationNormal(match.params.id);
    }
  })
)(OrganizationEdit);



// WEBPACK FOOTER //
// ./src/components/settings/organizationEdit/index.js